import idx from 'idx';
import { connect } from 'react-redux';
import partial from 'lodash/partial';
import { reduxForm, formValueSelector } from 'redux-form';
import { getProjectIdFromUrl, isEliteReserved } from 'project/utils';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { reserve } from 'project/ducks/elite';
import ReservationForm from 'project/components/reservation_form';

export const FORM_NAME = 'ELITE_RESERVATION_FORM';

export function mapStateToProps(state) {
  const selector = formValueSelector(FORM_NAME);
  const disabled = !selector(state, 'confirm');

  return {
    isReserving: idx(state, _ => _.project.elite.isReserving),
    reserveError: state.project.elite.error,
    isReserved: isEliteReserved(state),
    disabled,
  };
}

export function mapDispatchToProps(dispatch, { params }) {
  const projectId = getProjectIdFromUrl(params);
  return bindActionCreators({
    onSubmit: partial(reserve, projectId),
  }, dispatch);
}

const EliteReservationForm = reduxForm({
  form: FORM_NAME,
})(ReservationForm);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EliteReservationForm));



// WEBPACK FOOTER //
// ./project/containers/reservation_form.js